/**
 * RESPONSIBILITY: one photograph in a Visit page gallery.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Img } from '@framework/core/decorators';

@Row()
export class VisitPictureRow {
  @Img({ label: 'Picture', folder: 'visit', maxSizeMb: 12, size: '1200 × 800' })
  image!: ImageValue;

  @Text({ label: 'Caption', maxLength: 300 })
  caption!: string;
}
